import axios, { InternalAxiosRequestConfig } from 'axios';
import { LoginCredentials, LoginSuccessResponse, LoginErrorResponse } from '../types/auth';

const BASE_URL = 'https://madares.maksab.om';

// Create axios instance with base configuration
export const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Add request interceptor to add auth token
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('auth_token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Auth service
export const authService = {
    login: async (credentials: LoginCredentials): Promise<LoginSuccessResponse> => {
        try {
            const response = await api.post<LoginSuccessResponse>('/api/v1/guardian/auth/login', credentials);
            // Store token in localStorage
            localStorage.setItem('auth_token', response.data.data.token);
            return response.data;
        } catch (error: unknown) {
            if (axios.isAxiosError(error) && error.response) {
                const errorResponse = error.response.data as LoginErrorResponse;
                throw new Error(errorResponse.message || 'Authentication failed');
            }
            throw new Error('An unexpected error occurred');
        }
    },

    adminLogin: async (credentials: LoginCredentials): Promise<LoginSuccessResponse> => {
        try {
            const response = await api.post<LoginSuccessResponse>('/api/v1/admin/auth/login', credentials);
            // Store token in localStorage
            localStorage.setItem('auth_token', response.data.data.token);
            localStorage.setItem('role', 'admin');
            return response.data;
        } catch (error: unknown) {
            if (axios.isAxiosError(error) && error.response) {
                const errorResponse = error.response.data as LoginErrorResponse;
                throw new Error(errorResponse.message || 'Authentication failed');
            }
            throw new Error('An unexpected error occurred');
        }
    },

    logout: () => {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('role');
    },

    getToken: (): string | null => {
        return localStorage.getItem('auth_token');
    },
}; 